import { AddCircle, HomeIcon, PickleBall, SearchPersonOutline } from '@/components/icons'
import { ROUTE_DASHBOARD, ROUTE_NEW_MATCH, ROUTE_PLAY, ROUTE_PLAYERS } from '@/constants/Routes'
import { useAppSelector } from '@/hooks/useRedux'
import { authSelector } from '@/pages/auth/selectors'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

export const MobileSidebar = () => {
  const { t } = useTranslation()

  const location = useLocation()
  const { token } = useAppSelector(authSelector)

  return (
    <div className="flex lg:hidden bg-white h-[72px] p-2 fixed bottom-0 w-screen z-10 justify-between">
      <Link
        to={ROUTE_PLAYERS}
        className={`flex flex-col flex-1 rounded-lg items-center justify-center ${
          location.pathname === ROUTE_PLAYERS ? 'bg-navy-900 bg-opacity-10' : ''
        } `}
      >
        <div>
          <SearchPersonOutline
            className={`${
              location.pathname.includes(ROUTE_PLAYERS) ? 'opacity-100' : 'opacity-50'
            } w-6 h-6 text-navy-900`}
          />
        </div>
        <span
          className={`text-[10px] font-medium text-navy-900 ${
            location.pathname === ROUTE_PLAYERS ? 'opacity-100' : 'opacity-50'
          }`}
        >
          {t('common.players')}
        </span>
      </Link>

      {token && (
        <Link
          to={ROUTE_NEW_MATCH}
          className={`flex flex-col flex-1 rounded-lg items-center justify-center ${
            location.pathname === ROUTE_NEW_MATCH ? 'bg-navy-900 bg-opacity-10' : ''
          } `}
        >
          <div>
            <AddCircle
              className={`${
                location.pathname === ROUTE_NEW_MATCH ? 'opacity-100' : 'opacity-50'
              } w-6 h-6 text-navy-900`}
            />
          </div>
          <span
            className={`text-[10px] font-medium text-navy-900 ${
              location.pathname === ROUTE_NEW_MATCH ? 'opacity-100' : 'opacity-50'
            }`}
          >
            {t('common.newMatch')}
          </span>
        </Link>
      )}

      {token && (
        <Link
          to={ROUTE_PLAY}
          className={`flex flex-col flex-1 rounded-lg items-center justify-center ${
            location.pathname === ROUTE_PLAY ? 'bg-navy-900 bg-opacity-10' : ''
          } `}
        >
          <div>
            <PickleBall
              className={`${
                location.pathname.includes(ROUTE_PLAY) ? 'opacity-100' : 'opacity-50'
              } w-6 h-6 text-navy-900`}
            />
          </div>
          <span
            className={`text-[10px] font-medium text-navy-900 ${
              location.pathname === ROUTE_PLAY ? 'opacity-100' : 'opacity-50'
            }`}
          >
            {t('common.play')}
          </span>
        </Link>
      )}

      {token && (
        <Link
          to={ROUTE_DASHBOARD}
          className={`flex flex-col flex-1 rounded-lg items-center justify-center ${
            location.pathname === ROUTE_DASHBOARD ? 'bg-navy-900 bg-opacity-10' : ''
          } `}
        >
          <div>
            <HomeIcon
              className={`${
                location.pathname === ROUTE_DASHBOARD ? 'opacity-100' : 'opacity-50'
              } w-6 h-6 text-navy-900`}
            />
          </div>
          <span
            className={`text-[10px] font-medium text-navy-900 ${
              location.pathname === ROUTE_DASHBOARD ? 'opacity-100' : 'opacity-50'
            }`}
          >
            {t('common.home')}
          </span>
        </Link>
      )}
    </div>
  )
}
